"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortOrder;
(function (SortOrder) {
    SortOrder["asc"] = "ASC";
    SortOrder["desc"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var ConditionType;
(function (ConditionType) {
    ConditionType["and"] = "AND";
    ConditionType["or"] = "OR";
})(ConditionType = exports.ConditionType || (exports.ConditionType = {}));
var FilterOperatorTypes;
(function (FilterOperatorTypes) {
    FilterOperatorTypes["empty"] = "EMPTY";
    FilterOperatorTypes["notEmpty"] = "NOT_EMPTY";
    FilterOperatorTypes["equals"] = "EQUALS";
    FilterOperatorTypes["notEquals"] = "NOT_EQUALS";
    FilterOperatorTypes["greaterThanOrEqual"] = "GTE";
    FilterOperatorTypes["greaterThan"] = "GT";
    FilterOperatorTypes["lessThanEqual"] = "LTE";
    FilterOperatorTypes["lessThan"] = "LT";
    FilterOperatorTypes["is"] = "IS";
    FilterOperatorTypes["isNot"] = "IS_NOT";
    FilterOperatorTypes["contains"] = "CONTAINS";
    FilterOperatorTypes["notContains"] = "NOT_CONTAINS";
    FilterOperatorTypes["startsWith"] = "STARTS_WITH";
    FilterOperatorTypes["endsWith"] = "ENDS_WITH";
})(FilterOperatorTypes = exports.FilterOperatorTypes || (exports.FilterOperatorTypes = {}));
var AggregationType;
(function (AggregationType) {
    AggregationType["term"] = "TERM";
    AggregationType["range"] = "RANGE";
})(AggregationType = exports.AggregationType || (exports.AggregationType = {}));
var AggregationPropertyType;
(function (AggregationPropertyType) {
    AggregationPropertyType["boolean"] = "boolean";
    AggregationPropertyType["string"] = "string";
    AggregationPropertyType["number"] = "number";
})(AggregationPropertyType = exports.AggregationPropertyType || (exports.AggregationPropertyType = {}));
var MetricAggregation;
(function (MetricAggregation) {
    MetricAggregation["avg"] = "avg";
    MetricAggregation["count"] = "value_count";
    MetricAggregation["distinct"] = "cardinality";
    MetricAggregation["max"] = "max";
    MetricAggregation["min"] = "min";
    MetricAggregation["sum"] = "sum";
})(MetricAggregation = exports.MetricAggregation || (exports.MetricAggregation = {}));
//# sourceMappingURL=searchTypes.js.map